var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<input kendo-combo-box k-ng-model=\"model[options.key]\" ng-required=\"to.required\" k-options=\"combo.opzioni\" style=\"width: 100%; background-color: #e6f2ff;\"/>\n<input type=\"hidden\" name=\"{{options.key}}ToValidate\" ng-model=\"model[options.key]\" ng-required=\"to.required\"/>\n";
var id1="bsscombo.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;